// extracted by mini-css-extract-plugin
export default {"usertext":"UserText_usertext__YoC1k","usertext__title":"UserText_usertext__title__zy6xR","usertext__description":"UserText_usertext__description__sxxxv"};